
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbDropdownConfig, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrimeNG } from 'primeng/config';
import { ProcesosService } from '../../../services/centralization/procesos.service';
import { EditarConfirmarComponent } from '../../modals/centralizacion-remuneraciones/editar-confirmar/editar-confirmar.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

import { AuthorizationService } from '../../../services';
import { dutchRangeLabel } from '../../../shared/dutchRangeLabel';
import { PipesModule } from '../../../shared/pipes';
import { CalendarModule } from 'primeng/calendar';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-list-process',
  imports: [CommonModule,
    ReactiveFormsModule, NgbDropdownModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    CalendarModule,
    MatTableModule,
    MatPaginatorModule, MatTooltipModule,
    PipesModule],
  templateUrl: './list-process.component.html',
  styleUrls: ['./list-process.component.css'],
  animations: [
    trigger("detailExpand", [
      state("collapsed, void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)"),
      ),
      transition(
        "expanded <=> void",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)"),
      ),
    ]),
  ],

})
export class ListProcessComponent {

  filtrosForm: FormGroup;
  procesoEstados: any = [
    { name: 'Abierto', value: 1 },
    { name: 'Cerrado', value: 2 }
  ];
  procesoTipos: any = [
    { name: 'Normal', value: 'Normal' },
    { name: 'Especial', value: 'Especial' }
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: any[] = [
    'procesoTipo',
    'procesoNombre',
    'procesoPeriodo',
    'procesoFechaCreacion',
    'procesoEstado',
    'procesoCentros',
    'procesoOpciones'
  ];
  procesos: any = [];
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 50];
  totalRows = 0;
  periodoSelected: string = '';
  usuarioActual!: any;

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _spinner: NgxSpinnerService,
    private readonly _toastr: ToastrService,
    private readonly _modalService: NgbModal,
    private readonly _router: Router,
    private readonly _primengConfig: PrimeNG,
    private readonly _procesosService: ProcesosService,
    public AuthorizationService: AuthorizationService,
    config: NgbDropdownConfig
  ) {
    this.filtrosForm = this._formBuilder.group({
      procesoNombre: [''],
      procesoPeriodo: [''],
      procesoEstado: [''],
      procesoTipo: ['']
    });
    config.placement = 'bottom-end';
  }


  ngOnInit(): void {
    this.obtenerUsuarioActual();
    this.obtenerProcesosFiltrados(this.pageSize, 0);
    this._primengConfig.setTranslation({
      monthNames: [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ],
      monthNamesShort: [
        "ENE", "FEB", "MAR", "ABR", "MAY", "JUN",
        "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"
      ],
    });
  }

  ngAfterViewInit() {
    this.paginator._intl.itemsPerPageLabel = 'Filas por página';
    this.paginator._intl.nextPageLabel = 'Página Siguiente';
    this.paginator._intl.previousPageLabel = 'Página Anterior';
    this.paginator._intl.getRangeLabel = dutchRangeLabel;
    this.dataSource.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      this.obtenerProcesosFiltrados(this.paginator.pageSize, this.paginator.pageIndex);
    });
  }

  expandCollapse(element: any): void {
    if (element.expanded !== null) {
      element.expanded = !element.expanded;
    }
  }

  onChangePeriodo(event: any) {
    console.log(event);
    const date = new Date(event);
    const monthNames = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    this.periodoSelected = `${month}/${year}`;
    console.log('formattedPeriodo:', this.periodoSelected);
  }

  limpiarFiltros() {
    this.filtrosForm.reset({
      procesoNombre: '',
      procesoPeriodo: '',
      procesoEstado: '',
      procesoTipo: ''
    });
    this.periodoSelected = '';
    this.pageSize = 5;
    this.obtenerProcesosFiltrados();
  }

  obtenerProcesosFiltrados(limit?: any, offset?: any) {
    this._spinner.show();

    if (!limit && !offset) {
      limit = this.paginator.pageSize;
      offset = this.paginator.pageIndex;
    }
    const procNombre = this.filtrosForm.controls['procesoNombre'].value;
    const procTipo = this.filtrosForm.controls['procesoTipo'].value;
    const procPeriodo = this.periodoSelected;
    const estProcesoId = this.filtrosForm.controls['procesoEstado'].value;

    this._procesosService.listarProcesosFiltros(limit, offset, procNombre, procTipo, procPeriodo, estProcesoId).subscribe({
      next: async (data: any) => {
        this.procesos = data.procesosPaginados.rows
        this.totalRows = data.procesosPaginados.count;

        console.log('Procesos listados: ', this.procesos);
        const procesosSinCentros = [];
        for (const proceso of this.procesos) {
          if (proceso.centroProceso.length == 0) {
            procesosSinCentros.push(proceso.procId);
          }
        }

        if (procesosSinCentros.length > 0) {
          console.log('Procesos sin centros: ', procesosSinCentros);
          for (const procId of procesosSinCentros) {
            await this.quitarProcesosIncompletos(procId);
          }
          this.obtenerProcesosFiltrados(this.pageSize, 0);
        } else {
          this.dataSource = new MatTableDataSource(this.procesos);
        }

        this._spinner.hide();
      },
      error: (error: any) => {
        console.log(error);
        this._spinner.hide();
      }
    });
  }

  visualizarProceso(procId: any, procTipo: any) {
    this._spinner.show();
    this._router.navigate(['process/process-detail/', procId, procTipo]);
  }

  abrirModalEliminarProceso(procId: any, procesoNombre: string) {
    const modalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Proceso';
    modalRef.componentInstance.texto = `¿Está seguro de querer eliminar el Proceso: “${procesoNombre}”?`;
    modalRef.result.then(
      (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          this._spinner.show();
          this._procesosService.actualizarEstadoProceso(procId, 3).subscribe({
            next: (data: any) => {
              console.log(data);
              this.obtenerProcesosFiltrados();
              this._toastr.success('Proceso eliminado correctamente.', 'Éxito');
            },
            error: (error: any) => {
              console.log(error);
              this._spinner.hide();
            }
          });
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }

  validarAlfanumerico(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value;
    const valorValidado = valor.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚ ]/g, '');
    if (valor !== valorValidado) {
      input.value = valorValidado;
      this.filtrosForm.controls['procesoNombre'].setValue(valorValidado);
    }
  }

  abrirModalReabrirProceso(procId: any, procTipo: any, procNombre: any) {
    const modalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Reabrir Proceso';
    modalRef.componentInstance.texto = `¿Está seguro de querer reabrir el Proceso ${procTipo}: “${procNombre}”?`;
    modalRef.result.then(
      async (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          this.reabrirProceso(procId, procTipo);
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }

  reabrirProceso(procId: any, procTipo: any) {
    this._spinner.show();
    let userName = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
    }

    const currentDateTime = new Date().toISOString();

    const body = {
      procId: procId,
      procTipo: procTipo,
      centProcUpdateAt: currentDateTime,
      centProcUpdateFor: userName
    };

    this._procesosService.reabrirProceso(body).subscribe({
      next: (data: any) => {
        console.log(data);
        this._toastr.success('Proceso reabierto correctamente.', 'Éxito');
        this.visualizarProceso(procId, procTipo);
      },
      error: (error: any) => {
        console.log(error);
        this._spinner.hide();
      }
    });
  }

  obtenerUsuarioActual() {
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.usuarioActual = parsedUser;
    } else {
      this._toastr.warning('Error al obtener el usuario actual.', 'Error');
      this._router.navigate(['/not-authorized']);
    }
  }

  quitarProcesosIncompletos(procId: any) {
    return new Promise((resolve, reject) => {
      this._procesosService.actualizarEstadoProceso(procId, 3).subscribe({
        next: (data: any) => {
          console.log('Datos recibidos:', data);
          resolve(data);
        },
        error: (error: any) => {
          console.error('Error recibido:', error);
          reject(error);
        },
      });
    });
  }
  costCenter(): void {
    this._router.navigate(['cost-center']);
  }
  createProcess(select: any): void {
    if (select === 'Normal') {
      this._router.navigate(['process/normal-process']);
    } else if (select === 'Especial') {
      this._router.navigate(['process/special-process']);
    }
  }

}
